import { TranslatedText } from "$src/domain/core/TranslatedText";
import { ProjectDetail, ProjectPrices } from "../ProjectDetail";
import { fakeDeliveryTypes } from "./FakeDeliveryTypes";



export const fakeProjectPrices: ProjectPrices = {
    totalAmountIncVat: 11930.54,
    totalAmountIncVatNoDiscount: 2060,
    totalDiscountExVat: -170,
    totalDiscountIncVat: -204,
    amounts: [
        {
            vatPercent: 20,
            vatAmount: 248,
            amountExVat: 1240,
            amountIncVat: 1488
        },
        {
            vatPercent: 10,
            vatAmount: 98,
            amountExVat: 442,
            amountIncVat: 540
        }
    ],
    totalMarginExVat: 215,
    totalMarginPercent: 11.23,
    byCategories: [
        {
            category: [
                {
                    languageCode: "FR",
                    name: "Meubles"
                },
                {
                    languageCode: "EN",
                    name: "Cabinets"
                }
            ],
            amountExVatNoDiscount: 2500,
            amountIncVatNoDiscount: 2600,
            discountExVat: -50,
            discountIncVat: -60,
            amountExVat: 2600,
            amountIncVat: 2700,
            marginExVat: -50,
            order: 1
        },
        {
            category: [
                {
                    languageCode: "FR",
                    name: "Electroménagers"
                },
                {
                    languageCode: "EN",
                    name: "Appliances"
                }
            ],
            amountExVatNoDiscount: 310,
            amountIncVatNoDiscount: 372,
            discountExVat: -25,
            discountIncVat: -30,
            amountExVat: 285,
            amountIncVat: 342,
            marginExVat: 35,
            order: 2
        },
        {
            category: [
                {
                    languageCode: "FR",
                    name: "Sanitaires"
                },
                {
                    languageCode: "EN",
                    name: "Sanitary"
                }
            ],
            amountExVatNoDiscount: 200,
            amountIncVatNoDiscount: 240,
            discountExVat: -20,
            discountIncVat: -24,
            amountExVat: 180,
            amountIncVat: 216,
            marginExVat: 300,
            order: 3
        },
        {
            category: [
                {
                    languageCode: "FR",
                    name: "Plan de travail"
                },
                {
                    languageCode: "EN",
                    name: "Worktops"
                }
            ],
            amountExVatNoDiscount: 300,
            amountIncVatNoDiscount: 360,
            discountExVat: -20,
            discountIncVat: -24,
            amountExVat: 280,
            amountIncVat: 336,
            marginExVat: -400,
            order: 5
        },
        {
            category: [
                {
                    languageCode: "FR",
                    name: "Panneaux"
                },
                {
                    languageCode: "EN",
                    name: "Panels"
                }
            ],
            amountExVatNoDiscount: 240,
            amountIncVatNoDiscount: 288,
            discountExVat: -15,
            discountIncVat: -18,
            amountExVat: 225,
            amountIncVat: 270,
            marginExVat: 25,
            order: 6
        },
        {
            category: [
                {
                    languageCode: "FR",
                    name: "Services"
                },
                {
                    languageCode: "EN",
                    name: "Services"
                }
            ],
            amountExVatNoDiscount: 240,
            amountIncVatNoDiscount: 288,
            discountExVat: -15,
            discountIncVat: -18,
            amountExVat: 225,
            amountIncVat: 270,
            marginExVat: 25,
            order: 4
        },
        {
            category: [
                {
                    languageCode: "FR",
                    name: "Autres"
                },
                {
                    languageCode: "EN",
                    name: "Others"
                }
            ],
            amountExVatNoDiscount: 240,
            amountIncVatNoDiscount: 288,
            discountExVat: -15,
            discountIncVat: -18,
            amountExVat: 225,
            amountIncVat: 270,
            marginExVat: 25,
            order: 8
        },
        {
            category: [
                {
                    languageCode: "FR",
                    name: "Accessoires"
                },
                {
                    languageCode: "EN",
                    name: "Accessory"
                }
            ],
            amountExVatNoDiscount: 240,
            amountIncVatNoDiscount: 288,
            discountExVat: -15,
            discountIncVat: -18,
            amountExVat: 225,
            amountIncVat: 270,
            marginExVat: 25,
            order: 7
        }
    ],
    currencySymbol: "€",
    currency: 'EUR'
};

export const fakeProjectDetail: ProjectDetail = {
    items: [
        {
            id: "item1",
            code: "f001",
            product: {
                code: "oven",
                mainCategory: "Four",
                description: "Four encastrable électrique 60 cm",
                unit: {
                    code: "U001",
                    value: "unité"
                }
            },
            quantity: 1,
            prices: {
                discountPercent: 10,
                pointPrice: 500,
                costPriceExVat: 400,
                salesPriceExVat: 450,
                totalSalesPriceExVat: 450,
                totalSalesPriceIncVat: 540,
                vatAmount: 90,
                vatPercent: 20,
                marginAmount: 50,
                marginPercent: 11.11
            },
            drawing: {},
            model: {
                catalog: {
                    catalogName: "Catalog 2024"
                }
            },
            location: {
                mainPos: 1,
                subPos: 1,
                itemPos: 1,
                text: "Cuisine - Module 1"
            },
            comments: []
        },
        {
            id: "item2",
            code: "c001",
            product: {
                code: "cooktop",
                mainCategory: "Plaque de cuisson",
                description: "Plaque de cuisson vitrocéramique 60 cm",
                unit: {
                    code: "U001",
                    value: "unité"
                }
            },
            quantity: 1,
            prices: {
                discountPercent: 5,
                pointPrice: 300,
                costPriceExVat: 250,
                salesPriceExVat: 285,
                totalSalesPriceExVat: 285,
                totalSalesPriceIncVat: 342,
                vatAmount: 57,
                vatPercent: 20,
                marginAmount: 35,
                marginPercent: 12.28
            },
            drawing: {},
            model: {
                catalog: {
                    catalogName: "Catalog 2024"
                }
            },
            location: {
                mainPos: 1,
                subPos: 2,
                itemPos: 2,
                text: "Cuisine - Module 1"
            },
            comments: []
        },
        {
            id: "item3",
            code: "s001",
            product: {
                code: "sink",
                mainCategory: "Évier",
                description: "Évier inox double bac",
                unit: {
                    code: "U001",
                    value: "unité"
                }
            },
            quantity: 1,
            prices: {
                discountPercent: 8,
                pointPrice: 200,
                costPriceExVat: 150,
                salesPriceExVat: 180,
                totalSalesPriceExVat: 180,
                totalSalesPriceIncVat: 216,
                vatAmount: 36,
                vatPercent: 20,
                marginAmount: 30,
                marginPercent: 16.67
            },
            drawing: {},
            model: {
                catalog: {
                    catalogName: "Catalog 2024"
                }
            },
            location: {
                mainPos: 1,
                subPos: 3,
                itemPos: 3,
                text: "Cuisine - Module 1"
            },
            comments: []
        },
        {
            id: "item4",
            code: "c002",
            product: {
                code: "base_cabinet",
                mainCategory: "Meuble bas",
                description: "Meuble bas avec tiroirs",
                unit: {
                    code: "U001",
                    value: "unité"
                }
            },
            quantity: 2,
            prices: {
                discountPercent: 7,
                pointPrice: 150,
                costPriceExVat: 120,
                salesPriceExVat: 140,
                totalSalesPriceExVat: 280,
                totalSalesPriceIncVat: 336,
                vatAmount: 56,
                vatPercent: 20,
                marginAmount: 40,
                marginPercent: 14.29
            },
            drawing: {},
            model: {
                catalog: {
                    catalogName: "Catalog 2024"
                }
            },
            location: {
                mainPos: 2,
                subPos: 1,
                itemPos: 1,
                text: "Cuisine - Module 2"
            },
            comments: []
        },
        {
            id: "item5",
            code: "c003",
            product: {
                code: "tall_cabinet",
                mainCategory: "Meuble colonne",
                description: "Meuble colonne pour rangement",
                unit: {
                    code: "U001",
                    value: "unité"
                }
            },
            quantity: 1,
            prices: {
                discountPercent: 10,
                pointPrice: 250,
                costPriceExVat: 200,
                salesPriceExVat: 225,
                totalSalesPriceExVat: 225,
                totalSalesPriceIncVat: 270,
                vatAmount: 45,
                vatPercent: 20,
                marginAmount: 25,
                marginPercent: 11.11
            },
            drawing: {},
            model: {
                catalog: {
                    catalogName: "Catalog 2024"
                }
            },
            location: {
                mainPos: 2,
                subPos: 2,
                itemPos: 2,
                text: "Cuisine - Module 2"
            },
            comments: []
        }
    ],
    prices: fakeProjectPrices,
    schedule: undefined,
    delivery: {
        isCustomerAddress: false,
        addressFrom: undefined,
        addressTo: undefined,
        geoLocationFrom: undefined,
        geoLocationTo: undefined,
        carKilometerDistance: 0,
        deliveryType: fakeDeliveryTypes[0]
    },
    name: "",
    dateCreated: "",
    storeName: ""
};
